import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";
import Table from "../../core/pagination/datatable";
import { PlusCircle } from "feather-icons-react/build/IconComponents";

import { showSwalConfirmationAlert } from "../../Api/ConfirmationMessage";
import { DeleteRequest, GetRequest } from "../../Api/ApiFunctions";
import AddStaticAccount from "./AddStaticAccount";

function StaticAccounts() {
  const [dataSource, setDataSource] = useState(null);

  const columns = [
    {
      title: "Account Name",
      dataIndex: "account_name",
      sorter: (a, b) => a.account_name.length - b.account_name.length,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <a
              className="confirm-text p-2"
              onClick={() =>
                showSwalConfirmationAlert(() => DeleteAccount(record.id))
              }
            >
              <i data-feather="trash-2" className="feather-trash-2"></i>
            </a>
          </div>
        </div>
      ),
    },
  ];
  const fetchData = async () => {
    const res = await GetRequest("mon");
    if (res) {
      setDataSource(res);
    }
  };

  const DeleteAccount = async (id) => {
    const res = await DeleteRequest(`mon/${id}`);
    if (res) {
      fetchData();
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Monthly expense</h4>
                <h6>Manage your Monthly expense</h6>
              </div>
            </div>
            <div className="page-btn">
              <a
                to="#"
                className="btn btn-added"
                data-bs-toggle="modal"
                data-bs-target="#new-account"
              >
                <PlusCircle className="me-2" />
                Add New Account
              </a>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-responsive">
                <Table columns={columns} dataSource={dataSource} />
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
        <AddStaticAccount FetchNewData={fetchData} />
      </div>
    </>
  );
}

export default StaticAccounts;
